module.exports = __webpack_public_path__ + "static/media/filtering.6b7c1cbf.svg";